import { ValidationObserver, ValidationProvider } from "vee-validate";
import { MaintenanceMixin } from '@/mixins/Maintenance';
import { EventLocationsMixin } from "@/mixins/EventLocations";
import {MaintenancePriority} from "@/enums/MaintenancePriority";
import {MaintenanceRequestStatus} from "@/enums/MaintenanceRequestStatus";
import {dateFormats} from "@/consts/DateTimeFormats";
import moment from "moment/moment";
import {ResidentStatus} from "@/enums/ResidentStatus";

export default {
  name: "MaintenanceRequestEditDlg",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mixins: [MaintenanceMixin, EventLocationsMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      request: null,
      selectedTechnician: null,
      estimatedDeliveryDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menu: false,
      reqType: {
        id: "",
        typeId: "",
        name: "",
        category: "",
        department: "",
        icon: ""
      },
      newMaintRes: null,
    }
  },
  computed: {
    maintenanceTypes() {
      return this.$store.state.maintenanceModule.maintenanceTypes;
    },
    residentsList() {
      return this.$store.state.residentModule.residentsShortData.filter(resident => resident.status !== ResidentStatus.Departed);
    },
    maintenanceCategories() {
      return this.$store.getters.maintenanceCategories;
    },
    maintenancePriority() {
      return Object.values(MaintenancePriority);
    },
    isInProgress() {
      return this.request.status === MaintenanceRequestStatus.InProgress;
    },
    MaintenanceTechnicians() {
      return [...this.$store.state.userModule.maintenanceUsers, ...this.$store.state.userModule.maintenanceVendors.map(x => { return {...x, isVendor: true} })];
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    estimatedDeliveryDateFormatted() {
      const dateFormat = dateFormats.find(x => x.format === this.facility.dateFormat);
      return moment(this.estimatedDeliveryDate).format(dateFormat ? dateFormat.name : dateFormats[0].name);
    }
  },
  watch: {
    newMaintRes(res) {
      if(res != null) {
        this.request.residentId = res.id;
        this.request.residentName = res.name;
        this.request.roomName = res.roomName;
      }
    },
    reqType(requestType) {
      this.request.name = requestType.name;
      this.request.category = requestType.category;
      this.request.department = requestType.department;
      this.request.typeId = requestType.id;
      this.request.icon = requestType.icon;
    },
  },
  methods: {
    async open(request) {
      this.dialog = true;
      this.request = JSON.parse(JSON.stringify(request));

      this.selectedTechnician = request.assigneeEmail ?? null;
      this.estimatedDeliveryDate = this.request.estimatedCompletionDate ?? this.estimatedDeliveryDate;

      this.setRequestType();
      this.setResident();
    },
    close() {
      this.dialog = false;
      this.selectedTechnician = null;
    },
    setRequestType() {
      if(this.request.typeId) {
        const type = this.maintenanceTypes.find(item => item.id === this.request.typeId);
        this.reqType = { ...type };
      }
    },
    setResident() {
      if(this.request.residentId) {
        const resident = this.residentsList.find(item => item.id === this.request.residentId);
        this.newMaintRes = { ...resident };
      }
    },
    clearRes() {
      this.request.residentId = null;
      this.request.residentName = null;
      this.request.roomName = null;

      this.newMaintRes = null;
    },
    async submit() {
      this.loading = true;
      const request = JSON.parse(JSON.stringify(this.request));
      const maintenanceTechnician = this.MaintenanceTechnicians.find(x => x.email === this.selectedTechnician);

      request.assignee = maintenanceTechnician?.name ?? null;
      request.assigneeId = maintenanceTechnician?.id ?? null;
      request.assigneeEmail = maintenanceTechnician?.email ?? null;
      request.estimatedCompletionDate = this.estimatedDeliveryDate ?? null;

      delete request.id;
      delete request.assignedDate;
      delete request.dateTime;
      delete request.completedDateTime;

      await this.$store.dispatch("editMaintenanceRequest", {
        id: this.request.id,
        updates: request,
      }).then(() => {
        this.$toast.open({
          type: "success",
          message: this.$t("MaintenanceView.MaintenanceRequestSuccessfullyEdit")
        })
        this.loading = false;
        this.close()
      })
    }
  }
}